import { 
  SEND_MAIL,
  CLEAR_ERROR_SEND_MAIL,
  GET_OTP,
  DOWN_TIMEOUT_OTP,
  SEND_OTP,
  CLEAR_ERROR_SEND_OTP,
  CHANGE_ERROR_SEND_OTP,
  GET_NEW_OTP,
  LOGOUT
} from '../action';
import { setHeaders } from '../../../../utils/callApi';
import { OVER_TIME_GET_OTP_MESSAGE } from '../../../../utils/constants';

const initialState = {
  isSendingMail: false,
  isSentMailSuccess: false,
  isSentMailFail: false,
  errorSendMail: '',
  
  sendOTPRemain: 5,
  isSendingOTP: false,
  isSentOTPSuccess: false,
  isSentOTPFail: false,
  errorSendOTP: '',

  expiredTime: 0,
  timeoutOTP: null,

  getOTPRemain: 5,
  isGettingOTP: false,
  isGottenOTPSuccess: false,
  isGottenOTPFail: false,

  account: {},
  isLoggedIn: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SEND_MAIL.REQUEST:
      return {
        ...state,
        isSendingMail: true,
        isSentMailSuccess: false,
        isSentMailFail: false,
        errorSendMail: '',
      };
    case SEND_MAIL.SUCCESS:
      return {
        ...state,
        isSendingMail: false,
        isSentMailSuccess: true,
        isSentMailFail: false,
        errorSendMail: '',
        expiredTime: action.data.expiredTime,
        timeoutOTP: action.data.expiredTime - Number(new Date()),
        getOTPRemain: 5 - (action.data.resendTimes > action.data.genOtpTimes ? action.data.resendTimes : action.data.genOtpTimes),
        sendOTPRemain: 5 - action.data.authenTimes,
      };
    case SEND_MAIL.FAIL:
      return {
        ...state,
        isSendingMail: false,
        isSentMailSuccess: false,
        isSentMailFail: true,
        errorSendMail: action.data.error,
      };

    case GET_OTP.REQUEST:
      return {
        ...state,
        isGettingOTP: true,
        isGottenOTPSuccess: false,
        isGottenOTPFail: false,
      };
    case GET_OTP.SUCCESS:
      return {
        ...state,
        isGettingOTP: false,
        isGottenOTPSuccess: true,
        isGottenOTPFail: false,
        getOTPRemain: 5 - (action.data.resendTimes > action.data.genOtpTimes ? action.data.resendTimes : action.data.genOtpTimes),
        sendOTPRemain: 5 - action.data.authenTimes,
        expiredTime: action.data.expiredTime,
        timeoutOTP: state.timeoutOTP === null ? (action.data.expiredTime - Number(new Date())) : state.timeoutOTP,
      };
    case GET_OTP.FAIL:
      return {
        ...state,
        isGettingOTP: false,
        isGottenOTPSuccess: false,
        isGottenOTPFail: true,
        getOTPRemain: action.data.error === OVER_TIME_GET_OTP_MESSAGE ? 0 : state.getOTPRemain,
        errorSendOTP: action.data.error,
      };
    
    case SEND_OTP.REQUEST:
      return {
        ...state,
        isSendingOTP: true,
        isSentOTPSuccess: false,
        isSentOTPFail: false,
        sendOTPRemain: state.sendOTPRemain - 1
      };
    case SEND_OTP.SUCCESS:
      return {
        ...initialState,
        account: action.data,
        isLoggedIn: true,
      };
    case SEND_OTP.FAIL:
      return {
        ...state,
        isSendingOTP: false,
        isSentOTPSuccess: false,
        isSentOTPFail: true,
        errorSendOTP: action.data.error,
      };

    case CLEAR_ERROR_SEND_MAIL:
      return {
        ...state,
        isSendingMail: false,
        isSentMailSuccess: false,
        isSentMailFail: false,
        errorSendMail: '',
      };
    
    case CLEAR_ERROR_SEND_OTP:
      return {
        ...state,
        isSendingOTP: false,
        isSentOTPSuccess: false,
        isSentOTPFail: false,
        errorSendOTP: '',
      };
    
    case CHANGE_ERROR_SEND_OTP:
      return {
        ...state,
        errorSendOTP: action.params,
      };

    case DOWN_TIMEOUT_OTP: 
      return {
        ...state,
        timeoutOTP: (state.expiredTime - Number(new Date()) <= 0) ? null : state.expiredTime - Number(new Date()),
      };
    
    case GET_NEW_OTP:
      return {
        ...initialState,
      };

    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
